import { analyticsUtils } from 'utils/analytics-utils';
import { VariantAxisPoint, VariantAxisProduct } from 'modules/collections';
import { RelatedService } from 'modules/related-services';
import { removeSpecialCharacters } from 'utils';
import { KITCHEN_PDP_ELEMENT_BLOCK } from './kitchen-pdp-constants';

const getServiceGAInfo = (service: RelatedService, position: number, productId: string) => ({
  komplektyId: productId,
  productName: service.title,
  productId: service.categoryId,
  productPrice: service.price,
  productPosition: position + 1,
});

export const axisPointClickGAEvent = (clickedPoint: VariantAxisPoint, productId: string) => {
  analyticsUtils.clickProductEvent({
    elementType: 'komplekty',
    elementBlock: `${KITCHEN_PDP_ELEMENT_BLOCK} / variants`,
    komplektyId: productId,
    elementName: 'productNameLink',
    productName: removeSpecialCharacters(clickedPoint.displayedName),
    productId: clickedPoint.productId,
    productPrice: clickedPoint.price.toString(),
  });
};

export const serviceClickGAEvent = (service: RelatedService, position: number, productId: string) => {
  const serviceInfo = getServiceGAInfo(service, position, productId);

  analyticsUtils.sendEvent('GA:clickProduct', {
    elementType: 'product',
    elementBlock: `${KITCHEN_PDP_ELEMENT_BLOCK} / services`,
    elementName: 'productButtonLink',
    ...serviceInfo,
  });

  analyticsUtils.sendEvent('GA:addToCart', {
    elementType: 'button',
    elementBlock: `${KITCHEN_PDP_ELEMENT_BLOCK} / services`,
    productQuantity: 1,
    ...serviceInfo,
  });
};

export const serviceShowGAEvent = (service: RelatedService, position: number, productId: string) => {
  analyticsUtils.sendEvent('GA:impressions', {
    elementType: 'page',
    ...getServiceGAInfo(service, position, productId),
  });
};

export const previewClickGAEvent = (product: VariantAxisProduct, index: number) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: KITCHEN_PDP_ELEMENT_BLOCK,
    elementName: 'mediaPhoto',
    elementText: 'Фото',
    mediaLink: product.mediaPhoto[index],
    komplektyId: product.productId,
  });
};
